import { Component, ElementRef, TemplateRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PopupData } from '../users/users.component';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';

export interface DropDownInterface {
  codelistCode: any;
  codelistName: any;
}
@Component({
  selector: 'app-tms-user-training-review-period-edit',
  templateUrl: './tms-user-training-review-period-edit.component.html',
  styleUrls: ['./tms-user-training-review-period-edit.component.scss']
})
export class TmsUserTrainingReviewPeriodEditComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  displayReviewButton: boolean = false
  fieldLabelsListForExcel: any;
  columnsListForExcel: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  isProcessing = false;
  searchByPeriodId = [];
  getLmsTrainingReviewPeriodVwDetailsTableData: any = [];
  fromDate: any;
  reviewedOn: any;
  toDate: any;
  searchUserName: any;
  reviewPeriodId: any;
  reviewPeriodName: any;
  isFixedPeriod = true;
  childGridShow: any;
  snackbarRef: any;
  userName: any;
  userComments: any;
  userStatus: any;


  //dynamic grid
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  tmsUserTrainingReviewPeriodDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';

  constructor(public appService: AppService, public router: Router, public service: messageService, public dialog: MatDialog,
    public snackBar: MatSnackBar, public paginationService: PaginationService, public message: messageService, public elem: ElementRef) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    appService.isProcessingRep = false;
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tmsUserTrainingReviewPeriodDataForGrid.length, page, this.perPage, targetpage);
    if (this.tmsUserTrainingReviewPeriodDataForGrid.length > 0) {
      this.pagedItems = this.tmsUserTrainingReviewPeriodDataForGrid
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  onReviewDeSelect(tem: any) {
    this.selectedReviewStatusForTraining = [];
  }
  getCall() {
    this.tmsUserTrainingReviewPeriodDataForGrid = [];
    const data = {

      gridName: "TRAINING_REVIEW",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.columnsListForExcel = response.columnsList ?? "";
        this.columnList = response.fieldLabelsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND REVIEW_PERIOD_ID=" + this.message.reviewPeriodIdVal + " AND USER_ID=" + this.message.userIdVal;
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "TMS_USER_TRAINING_REVIEW_PERIOD",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",

          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          trainingReviewSearchVal: this.message.reviewPeriodIdVal,
          trainingReviewUserId: this.message.userIdVal,
          manualEntryDataFields: response.manualEntryDataFields
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.tmsUserTrainingReviewPeriodDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const fieldSize of data1.fieldSizeListArray) {
              const formattedSize = Number.parseInt(fieldSize, 10) + 'px';
              this.columnLists.fieldSizeListArray.push(formattedSize);
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];

              if (this.columnLists.invisibleColumnarray.includes(currentColumn)) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {

              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const typeDef of this.dataTypeList) {
                  if (typeDef.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = typeDef.fieldType;
                    break;
                  }
                }
              }
              for (const row of this.tmsUserTrainingReviewPeriodDataForGrid) {
                for (const typeDef of this.dataTypeList) {
                  if (typeDef.fieldType === 'CHECKBOX') {
                    const colName = typeDef.columnName;
                    row[colName] = row[colName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingReviewPeriodDataForGrid;
            this.collectionSize = this.tmsUserTrainingReviewPeriodDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingReviewPeriodDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingReviewPeriodDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tmsUserTrainingReviewPeriodDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.displayReviewButton = true;
      this.childCheckBoxs = true;
      this.selectedTrainings = this.tmsUserTrainingReviewPeriodDataForGrid;
      this.tmsUserTrainingReviewPeriodDataForGrid.forEach((row: { childCheckBoxs: boolean; USER_TRAINING_ID: any; }) => {
        row.childCheckBoxs = true;
        this.multiUsersArray.push({
          userTrainingId: row.USER_TRAINING_ID,
        });
      });
    } else {
      this.childCheckBoxs = false;
      this.displayReviewButton = false;
      this.selectedTrainings = [];
      this.tmsUserTrainingReviewPeriodDataForGrid.forEach((row: { childCheckBoxs: boolean; }) => {
        row.childCheckBoxs = false;
      });
      this.multiUsersArray = [];
    }
  }
  dataGridParentCheckBoxChecked1() {
    this.parentCheckBox = false;
    this.childCheckBoxs = false;
    this.displayReviewButton = false;
    this.selectedTrainings = [];
    this.tmsUserTrainingReviewPeriodDataForGrid.forEach((row: { childCheckBoxs: boolean; }) => {
      row.childCheckBoxs = false;
    });
    this.parentCheckBox = false;
    console.log("this.parentCheckBox=", this.parentCheckBox)
  }
  multiUsersArray: any = [];
  selectedTrainings: any = [];
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    console.log("list=", list);
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.displayReviewButton = true;
      this.multiUsersArray.push({
        userTrainingId: list.USER_TRAINING_ID,
      })
      this.selectedTrainings.push(list);
      console.log("selected", this.selectedTrainings)
    } else {
      list.childCheckBoxs = false;
      const removal = this.multiUsersArray.findIndex((removableUser: any) => removableUser.userTrainingId == list.USER_TRAINING_ID);
      if (removal > -1) { this.multiUsersArray.splice(removal, 1) };
      const removal1 = this.selectedTrainings.findIndex((removableUser: any) => removableUser.USER_TRAINING_ID == list.USER_TRAINING_ID);
      if (removal1 > -1) { this.selectedTrainings.splice(removal, 1) };
      console.log("this.multiUsersArray", this.multiUsersArray);
      if (this.tmsUserTrainingReviewPeriodDataForGrid.some((user: any) => user.childCheckBoxs)) {
        this.displayReviewButton = true;
      }
      if (this.tmsUserTrainingReviewPeriodDataForGrid.every((user: any) => !user.childCheckBoxs)) {
        this.displayReviewButton = false;
      }
    }
  }
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  refreshGridData() {
    this.isProcessing = true;
    this.getCall();
  }
  //end dynamic grid
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  dateTimeFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateTimeFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }
  listOfUsersData: any = {};
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  selectedReviewStatus: any = [];
  dropDownForReviewStatus: any = [];
  reviewStatusDropDown: any = [];
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  selectBoxForReviewStatus() {
    this.reviewStatusDropDown = [];
    this.reviewStatusDropDown = this.dropDownForReviewStatus.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  updateFunction() {
    this.isProcessing = true;
    if (this.listOfUsersData.comments == "" || this.listOfUsersData.comments == null) {
      alert("Please enter comments");
      this.isProcessing = false;
    } else if (this.selectedReviewStatus.length == 0) {
      alert("Please select Review Status");
      this.isProcessing = false;
    } else {
      this.listOfUsersData.reviewStatus = this.selectedReviewStatus[0]?.valueExp ?? null;
      this.listOfUsersData.toDate = this.toDate;
      this.listOfUsersData.fromDate = this.fromDate;
      this.appService.updateUserForReview(this.listOfUsersData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          this.appService.getUserEditPriodList(this.message.reviewPeriodIdVal, this.message.userIdVal).subscribe({
            next: (data: any) => {
              this.listOfUsersData = data[0];
              if (this.listOfUsersData.reviewStatus) {
                const matchingReviewStatus = this.dropDownForReviewStatus.find((item: any) => item.codelistCode == this.listOfUsersData.reviewStatus);
                if (matchingReviewStatus) {
                  this.selectedReviewStatus = [{
                    valueExp: matchingReviewStatus.codelistCode,
                    displayExp: matchingReviewStatus.codelistName
                  }]
                }
              }
              if (this.listOfUsersData.fromDateStr) {
                let fromdateValue = new Date(this.listOfUsersData.fromDateStr);
                this.fromDate = fromdateValue;
              } else {
                this.fromDate = null;
              }
              if (this.listOfUsersData.toDateStr) {
                let todateValue = new Date(this.listOfUsersData.toDateStr);
                this.toDate = todateValue;
              } else {
                this.toDate = null;
              }
              if (this.listOfUsersData.reviewedOnStr) {
                let reviewedOnVal = new Date(this.listOfUsersData.reviewedOnStr);
                this.listOfUsersData.reviewedOn = reviewedOnVal;
              } else {
                this.listOfUsersData.reviewedOn = null;
              }
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
            }
          });
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          this.appService.getUserEditPriodList(this.message.reviewPeriodIdVal, this.message.userIdVal).subscribe((data: any) => {
            this.listOfUsersData = data[0];
            if (this.listOfUsersData.reviewStatus) {
              const matchingReviewStatus = this.dropDownForReviewStatus.find((item: any) => item.codelistCode == this.listOfUsersData.reviewStatus);
              if (matchingReviewStatus) {
                this.selectedReviewStatus = [{
                  valueExp: matchingReviewStatus.codelistCode,
                  displayExp: matchingReviewStatus.codelistName
                }]
              }
            }
            if (this.listOfUsersData.fromDateStr) {
              let fromdateValue = new Date(this.listOfUsersData.fromDateStr);
              this.fromDate = fromdateValue;
            } else {
              this.fromDate = null;
            }
            if (this.listOfUsersData.toDateStr) {
              let todateValue = new Date(this.listOfUsersData.toDateStr);
              this.toDate = todateValue;
            } else {
              this.toDate = null;
            }
            if (this.listOfUsersData.reviewedOnStr) {
              let reviewedOnVal = new Date(this.listOfUsersData.reviewedOnStr);
              this.listOfUsersData.reviewedOn = reviewedOnVal;
            } else {
              this.listOfUsersData.reviewedOn = null;
            }
            this.isProcessing = false;
          })
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  CancelFunction() {
    this.router.navigate(['/dashboard/TmsUserTrainingReviewPeriodComponent']);
  }
  typeOfTrainingReview: any;
  trainingReviewComments: any;
  isActionRequired: boolean = false;
  isActionRequiredFun(e: any) {
    if (e.target.checked) {
      this.isActionRequired = true;
    } else {
      this.isActionRequired = false;
    }
  }
  @ViewChild('trainingReviwPopup', { static: true }) trainingReviwPopup: TemplateRef<any>;
  visibleTrainingReviewPopup: MatDialogRef<TemplateRef<any>>;
  searchTrainingReviewPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  foundReviewedTraining: any = [];
  reviewTrainingPopup(val: any) {
    if (this.selectedTrainings.length < 1) {
      this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 100,
        data: {
          message: "Please select training before review",
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error',
      });
      this.snackbarRef.onAction().subscribe(() => {
        this.snackbarRef.dismiss();
      });
    } else {
      this.foundReviewedTraining = this.selectedTrainings.filter((user: any) => user.REVIEW_STATUS == 'Reviewed')
      if (this.foundReviewedTraining.length > 0) {
        const statuses = this.foundReviewedTraining?.map((item: any) => item.TRAINING_NAME);
        const statusString = statuses.join(', ');
        alert(`Training(s) has already been reviewed! Training Name(s): ${statusString}`);
      } else {
        this.trainingReviewComments = "";
        this.isActionRequired = false;
        this.selectedReviewStatusForTraining = [];
        this.typeOfTrainingReview = val;
        this.visibleTrainingReviewPopup = this.dialog.open(this.trainingReviwPopup, this.searchTrainingReviewPopupConfig);
      }
    }
  }
  $userTrainingIdForReview: number = 0;
  $singleReview: boolean = false;

  reviewTrainingHover(list: any) {
    this.$userTrainingIdForReview = list.USER_TRAINING_ID
    if (list.REVIEW_STATUS == "Reviewed") {
      alert(`Training  already  reviewed`);
    } else {
      this.trainingReviewComments = "";
      this.isActionRequired = false;
      this.selectedReviewStatusForTraining = [];
      this.$singleReview = true
      this.visibleTrainingReviewPopup = this.dialog.open(this.trainingReviwPopup, this.searchTrainingReviewPopupConfig);
    }
  }
  cancelTrainingReviewPopupFunction() {
    this.visibleTrainingReviewPopup.close();
    this.$singleReview = false;
  }
  selectedReviewStatusForTraining: any = [];
  trainingReviewFun() {
    console.log(this.typeOfTrainingReview)
    if (this.typeOfTrainingReview == "selected") {
      this.dataGridParentCheckBoxChecked1();
      if (this.multiUsersArray.length < 1) {
        this.showSnackBar('Please select training before review', 'E');
      } else if (this.selectedReviewStatusForTraining.length < 1) {
        this.showSnackBar('Please select Review Status', 'E');
      } else if (this.trainingReviewComments == "" && this.isActionRequired) {
        this.showSnackBar('Please enter the Comments', 'E');
      }
      else {
        for (let k = 0; k < this.multiUsersArray.length; k++) {
          console.log(this.multiUsersArray[k].userTrainingId)
          const data = {
            reviewPeriodId: this.message.reviewPeriodIdVal,
            userTrainingId: this.multiUsersArray[k].userTrainingId,
            actionRequired: this.isActionRequired ? "Y" : "N",
            comments: this.trainingReviewComments,
            reviewStatus: this.selectedReviewStatusForTraining[0]?.valueExp ?? null
          }
          this.isProcessing = true;
          this.appService.updateUserTrainingReviewStatus(data).subscribe({
            next: (response: any) => {
              console.log(response, k);
              this.displayMessage = response.result;
              this.displayResultType = response.resultType;
              this.visibleTrainingReviewPopup.close();
              this.isProcessing = false;
              this.displayReviewButton = false;
              this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: this.displayResultType == 'S' ? 5000 : undefined,
                data: {
                  message: response.result,
                  type: response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: response.resultType == 'S' ? 'Success' : 'Error',
              });
              this.snackbarRef.onAction().subscribe(() => {
                this.snackbarRef.dismiss();
              });
              this.getCall();
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }
    } else if (this.typeOfTrainingReview == "All") {
      this.dataGridParentCheckBoxChecked1();
      for (let k = 0; k < this.tmsUserTrainingReviewPeriodDataForGrid.length; k++) {
        const data = {
          reviewPeriodId: this.message.reviewPeriodIdVal,
          userTrainingId: this.tmsUserTrainingReviewPeriodDataForGrid[k].userTrainingId,
          actionRequired: this.isActionRequired ? "Y" : "N",
          comments: this.trainingReviewComments,
          reviewStatus: this.selectedReviewStatusForTraining[0]?.valueExp ?? null
        }
        this.isProcessing = true;
        this.appService.updateUserTrainingReviewStatus(data).subscribe({
          next: (response: any) => {
            console.log(response, k);
            this.displayMessage = response.result;
            this.displayResultType = response.resultType;
            this.getCall();
            this.visibleTrainingReviewPopup.close();
            this.isProcessing = false;
            this.displayReviewButton = false;
            this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: response.result,
                type: response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: response.resultType == 'S' ? 'Success' : 'Error',
            });
            this.snackbarRef.onAction().subscribe(() => {
              this.snackbarRef.dismiss();
            });
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }
  trainingSingleReview() {
    if (!this.selectedReviewStatusForTraining.length) {
      this.showSnackBar('Please select Review Status', 'E');
    } else if (!this.trainingReviewComments && this.isActionRequired) {
      this.showSnackBar('Please enter the Comments', 'E');
    } else {
      const data = {
        reviewPeriodId: this.message.reviewPeriodIdVal,
        userTrainingId: this.$userTrainingIdForReview,
        actionRequired: this.isActionRequired ? "Y" : "N",
        comments: this.trainingReviewComments,
        reviewStatus: this.selectedReviewStatusForTraining[0]?.valueExp ?? null
      }
      this.isProcessing = true;
      this.$singleReview = false;
      this.appService.updateUserTrainingReviewStatus(data).subscribe({
        next: (response: any) => {
          this.displayMessage = response.result;
          this.displayResultType = response.resultType;
          this.visibleTrainingReviewPopup.close();
          this.isProcessing = false;
          this.displayReviewButton = false;
          this.showSnackBar(response.result, response.resultType);
          this.getCall();
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  //Excell & PDF
  whereValsForExcel: any;
  whereValsForExcelTemp: any;
  auditTrailsFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 1,
  };
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  isSaveReport: boolean = false;
  generateReport(value: any) {
    this.appService.isProcessingRep = true;
    let tname = "";
    let colList = "";
    let fieldList = "";
    let orderBy = "";
    if (this.auditTrailsFlag == 0) {
      tname = "TMS_USER_TRAINING_RECORD_REVIEW_VW";
      colList = this.columnsListForExcel;
      fieldList = this.fieldLabelsListForExcel;
    } else {
      orderBy = "CREATED_TS";
      tname = this.tableOrViewNameForAuditTrails;
      colList = this.columnListAuditTrails1;
      fieldList = this.fieldLabelsListForAuditTrails;
    }
    console.log(value, "--------------------");
    const data = {

      groupId: null
    }
    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: orderBy,
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms",
      module: "TRN",
      gridName: "Periodic Review",
      footer: this.selectedReportFooter,
      logoId: this.selectedReportLogoValue ?? null,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      reportName: this.reportName ?? "Report",
      currentStatus: "NA",
      groupName: "",

    }
    this.reportObj = { ...data1, ...data };
    debugger;
    if (value == 'Excel') {
      const pdfData = {
        ...this.reportObj, title: "User Training Review", columns: [],
        "informationTab": {
          "Report Name": "User Training Review",
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.appService.downloadexcelForChart(pdfData, "User_Training_Review.xlsx");
    } else {
      const pdfData = {
        ...this.reportObj, title: "User Training Review", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(',')
      }
      this.appService.downloadPdfForChart(pdfData, "User_Training_Review.pdf");
    }
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  generateReportPeridicReview(value: any) {
    this.appService.isProcessingRep = true;
    let tname = "";
    let colList = "";
    let fieldList = "";
    let orderBy = "";

    tname = "TMS_USER_TRAINING_RECORD_REVIEW_VW";
    colList = "ACTION_REQUIRED,COMMENTS,REVIEW_STATUS,REVIEWED_BY_NAME,REVIEWED_ON,VERSION,TRAINING_NAME,TRAINING_CODE,STATUS,EXPIRY_DATE,USER_TRAINING_STATUS,LEVEL_STATUS,CONSIDERED_FOR_REPORT,REASON_FOR_NOT_CONSIDERED_AT_REPORT,TRAINING_ASSIGNED_ON,DUE_DATE,STARTED_ON,COMPLETED_ON,CATEGORY_CODE,TYPE,TOTAL_DURATION,LANGUAGE,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,GROUP_NAME,IS_GROUP_ACTIVE,TRAINING_LEVEL,DUE_N_DAY_FROM_ASSIGNED,REMIND_N_DAY_BEFORE_DUE,REMIND_EVERY_N_DAYS,ESCALATE,ESCALATE_EVERY_N_DAYS,REPEAT_TRAINING,REPEAT_INTERVAL,REPEAT_INTERVAL_UNIT,ALLOWED_FAILED_ATTEMPTS,ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK,MAX_ALLOWED_FAILED_ATTEMPTS,ALLOW_TO_REVIEW_RESULTS,SHOW_ANSWERS_AT_REVIEW,OVERDUE_RM_APPROVAL_REQD,OVERDUE_QA_APPROVAL_REQD,LIST_OF_QA_USERS,DUE_N_DAY_FROM_OVERDUE_UNLOCK,RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT,USER_NAME,USR_FULLNAME,IS_USER_ACTIVE,EMAIL_ADDRESS,INTIMATION_SCHEDULED,INTIMATION_SENT_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,USER_TRAINING_COMMENTS,FINAL_SCORE,FAILED_ATTEMPTS,FAILED_ATTEMPTS_AFTER_UNLOCK,FAILED_ATTEMPT_REACHED,MAX_FAILED_ATTEMPT_REACHED,RELAUNCH_REASON,ESIGNATURE_DONE,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,NO_OF_OVERDUE_UNLOCK,NO_OF_FAILED_UNLOCK,NO_OF_TIMES_COMPLETED,TRAINER_NAME,SCHEDULED_TRAINING_STATUS,SCHEDULED_TRAINING_ASSESSMENT,START_DATE,END_DATE";
    fieldList = "Action Required,Comments,Review Status,Reviewed By Name,Reviewed On,Version,Training Name,Training Code,Status,Expiry Date,User Training Status,Level Status,Considered For Report,Reason for Not Considered at Report,Training Assigned On,Due Date,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Day From Assigned,Remind N Day Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow To Review Results,Show Answers At Review,Overdue Rm Approval Reqd,Overdue Qa Approval Reqd,List Of Qa Users,Due N Day From Overdue Unlock,Retake After N Min on Failed Attempt,User Name,Usr Fullname,User Active?,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,User Training Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,Esignature Done,Failed Lock Rm Approved On,Overdue Lock Rm Approved On,Overdue Lock Qa Approved On,No. Of Overdue Unlock,No. Of Failed Unlock,No. Of Times Completed,Trainer Name,Scheduled Training Status,Scheduled Training Assessment,Start Date,End Date";
    this.columnList = "Action Required,Comments,Review Status,Reviewed By Name,Reviewed On,Version,Training Name,Training Code,Status,Expiry Date,User Training Status,Level Status,Considered For Report,Reason for Not Considered at Report,Training Assigned On,Due Date,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Day From Assigned,Remind N Day Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow To Review Results,Show Answers At Review,Overdue Rm Approval Reqd,Overdue Qa Approval Reqd,List Of Qa Users,Due N Day From Overdue Unlock,Retake After N Min on Failed Attempt,User Name,Usr Fullname,User Active?,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,User Training Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,Esignature Done,Failed Lock Rm Approved On,Overdue Lock Rm Approved On,Overdue Lock Qa Approved On,No. Of Overdue Unlock,No. Of Failed Unlock,No. Of Times Completed,Trainer Name,Scheduled Training Status,Scheduled Training Assessment,Start Date,End Date";

    console.log(value, "--------------------");
    const data = {

      groupId: null
    }

    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: "EXPIRY_DATE",
      groupId: null,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms",
      logoId: this.selectedReportLogoValue ?? 0,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      reportName: this.reportName ?? "Report",
      currentStatus: "NA",
      groupName: "",
      "Period Id": this.message.reviewPeriodIdVal,
      "Selected User Id": this.message.userIdVal
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    if (value == 'Excel') {
      const pdfData = {
        ...this.reportObj, title: "User Training Review", columns: [],
        "userInformation": {
          "Review Period Name": this.message.reviewPeriodName,
          "Review Period From Date": this.fromDate,
          "Review Period To Date": this.toDate,
          "User Fullname": this.listOfUsersData.userFullname,
          "Review User": this.listOfUsersData.reviewUser,
          "Review Status": this.selectedReviewStatus[0].displayExp,
          "Review Comments": this.listOfUsersData.comments,
          "Reviewed On": this.listOfUsersData.reviewedOn,
          //  "Period Id": this.message.reviewPeriodIdVal,
          //  "Selected User Id":this.message.userIdVal
        },
        "informationTab": {
          "Report Name": "User Training Review",
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.appService.downloadexcelForPeridicReview(pdfData, "User_Training_Review.xlsx");
    } else {
      const pdfData = {
        ...this.reportObj, title: "User Training Review",
        "userInformation": {
          "Review Period Name": this.message.reviewPeriodName,
          "Review Period From Date": this.fromDate,
          "Review Period To Date": this.toDate,
          "User Fullname": this.listOfUsersData.userFullname,
          "Review User": this.listOfUsersData.reviewUser,
          "Review Status": this.selectedReviewStatus[0].displayExp,
          "Review Comments": this.listOfUsersData.comments,
          "Reviewed On": this.listOfUsersData.reviewedOn,
          //  "Period Id": this.message.reviewPeriodIdVal,
          //  "Selected User Id":this.message.userIdVal
        }, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(',')
      }
      this.appService.downloadPdfForPeridicReview(pdfData, "User_Training_Review.pdf");
    }
  }

  openReportPopup(item: any) {
    this.auditTrailsFlag = 0;
    this.columnList = "Action Required,Comments,Review Status,Reviewed By Name,Reviewed On,Version,Training Name,Training Code,Status,Expiry Date,User Training Status,Level Status,Considered For Report,Reason for Not Considered at Report,Training Assigned On,Due Date,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Day From Assigned,Remind N Day Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow To Review Results,Show Answers At Review,Overdue Rm Approval Reqd,Overdue Qa Approval Reqd,List Of Qa Users,Due N Day From Overdue Unlock,Retake After N Min on Failed Attempt,User Name,Usr Fullname,User Active?,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,User Training Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,Esignature Done,Failed Lock Rm Approved On,Overdue Lock Rm Approved On,Overdue Lock Qa Approved On,No. Of Overdue Unlock,No. Of Failed Unlock,No. Of Times Completed,Trainer Name,Scheduled Training Status,Scheduled Training Assessment,Start Date,End Date";
    this.dropDownForPdfColumn = this.columnList.split(',');
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  manuallyPicked: boolean;
  onCheckboxChange(event: MatCheckboxChange) {
    if (!event.checked) {
      this.manuallyPicked = false;
      this.selectedColumns = [];
    }
  }
  //end excell & pdf
  //audit trails
  whereClause: any;
  columnListAuditTrails: any;
  columnListAuditTrails1: any;
  fiveColumnForAuditTrails: any;
  spColumnForAuditTrails: any;
  fiveFieldLabelsColumnForAuditTrails: any;
  spFieldLabelsColumnForAuditTrails: any;
  fieldLabelsListForAuditTrails: any;
  tableOrViewNameForAuditTrails: any;
  columnListsAuditTrails: any = {};
  dataTypeListAuditTrails: any = [];
  listForAuditTrails: any = [];
  makeStickyColumnsAuditTrails: any;

  collectionSizeForAudtitrails: number;
  perPageForAudtitrails = 10;
  calculateTotalPagesForAudtitrails: number;
  pagerForAudtitrails: any = {};
  pagedItemsForAudtitrails: any[];

  @ViewChild('auditTrailPopup', { static: true }) auditTrailPopup: TemplateRef<any>;
  auditTrailPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }
  visibleAuditTrailPopup: MatDialogRef<TemplateRef<any>>;
  cancelReportPopupFunction() {
    this.visibleAuditTrailPopup.close();
  }
  paginationCallForAudtitrails(value: number) {
    this.perPageForAudtitrails = value;
    this.setPageForAudtitrails(this.pagerForAudtitrails.currentPageForAudtitrails, 0);
  }
  setPageForAudtitrails(page: number, targetpage: number) {
    if (page < 1 || page > this.pagerForAudtitrails.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerForAudtitrails = this.paginationService.getPager(this.listForAuditTrails.length, page, this.perPageForAudtitrails, targetpage);
    if (this.listForAuditTrails.length > 0) {
      this.pagedItemsForAudtitrails = this.listForAuditTrails?.slice(this.pagerForAudtitrails.startIndex, this.pagerForAudtitrails.endIndex + 1);
    }
  }
  //end audit trails
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const detail of this.organizationReportImageDetails) {
              console.log("this.organizationReportImageDetails=", detail.reportImageId, this.imageIdList[i]);

              if (detail.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown.push({
                  valueExp: detail.reportImageId,
                  displayExp: detail.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const detail of this.organizationReportImageDetails) {
          if (detail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown.push({
              valueExp: detail.reportImageId,
              displayExp: detail.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const item of this.reportLogoDropdown) {
          if (item.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = item.valueExp;
          }
        }
        this.reportLogoDropdown = [...this.reportLogoDropdown];
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("TRN")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistCode,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  ngOnInit() {
    this.isProcessing = true;
    if (!this.message.reviewPeriodIdVal || !this.message.userIdVal) {
      console.error("Missing required IDs for API call. Halting.");
      this.isProcessing = false;
      return;
    }

    forkJoin([
      this.appService.getCodeListsByGroup('PERIOD_REVIEW_STATUS')
    ]).subscribe(([typdropDownForReviewStatuseData]) => {

      this.dropDownForReviewStatus = typdropDownForReviewStatuseData;
      this.selectBoxForReviewStatus();

      this.appService.getUserEditPriodList(this.message.reviewPeriodIdVal, this.message.userIdVal).subscribe((data: any) => {
        this.listOfUsersData = data[0];
        if (this.listOfUsersData.reviewStatus) {
          const matchingReviewStatus = this.dropDownForReviewStatus.find((item: any) => item.codelistCode == this.listOfUsersData.reviewStatus);
          if (matchingReviewStatus) {
            this.selectedReviewStatus = [{
              valueExp: matchingReviewStatus.codelistCode,
              displayExp: matchingReviewStatus.codelistName
            }]
          }
        }
        if (this.listOfUsersData.fromDateStr) {
          let fromdateValue = new Date(this.listOfUsersData.fromDateStr);
          this.fromDate = fromdateValue;
        } else {
          this.fromDate = null;
        }
        if (this.listOfUsersData.reviewedOnStr) {
          let reviewedOnVal = new Date(this.listOfUsersData.reviewedOnStr);
          this.listOfUsersData.reviewedOn = reviewedOnVal;
        } else {
          this.listOfUsersData.reviewedOn = null;
        }
        if (this.listOfUsersData.toDateStr) {
          let todateValue = new Date(this.listOfUsersData.toDateStr);
          this.toDate = todateValue;
        } else {
          this.toDate = null;
        }
        this.isProcessing = false;
      })
      this.getCall();
    });
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("TRN", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();

  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall('TRAINING_REVIEW', 'TMS_USER_TRAINING_RECORD_REVIEW_VW', null, 0)
  }
  onChildValueEmitted() {
    this.getCall();
  };
  auditTrail: any = {};
  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  openAuditTrail(viewType: any, userTrainingReview: any) {
    this.message.tableOrView_Name = "TMS_USER_TRAINING_RECORD_REVIEW_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,USER_NAME,USR_FULLNAME,IS_USER_ACTIVE,EMAIL_ADDRESS,SCHEDULED_TRAINING_STATUS,SCHEDULED_TRAINING_ASSESSMENT,START_DATE,END_DATE,ACTION_REQUIRED,COMMENTS,REVIEW_STATUS,REVIEWED_BY_NAME,REVIEWED_ON,VERSION,STATUS,EXPIRY_DATE,USER_TRAINING_STATUS,LEVEL_STATUS,CONSIDERED_FOR_REPORT,REASON_FOR_NOT_CONSIDERED_AT_REPORT,TRAINING_ASSIGNED_ON,DUE_DATE,STARTED_ON,COMPLETED_ON,CATEGORY_CODE,TYPE,TOTAL_DURATION,LANGUAGE,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,GROUP_NAME,IS_GROUP_ACTIVE,TRAINING_LEVEL,DUE_N_DAY_FROM_ASSIGNED,REMIND_N_DAY_BEFORE_DUE,REMIND_EVERY_N_DAYS,ESCALATE,ESCALATE_EVERY_N_DAYS,REPEAT_TRAINING,REPEAT_INTERVAL,REPEAT_INTERVAL_UNIT,ALLOWED_FAILED_ATTEMPTS,ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK,MAX_ALLOWED_FAILED_ATTEMPTS,ALLOW_TO_REVIEW_RESULTS,SHOW_ANSWERS_AT_REVIEW,OVERDUE_RM_APPROVAL_REQD,OVERDUE_QA_APPROVAL_REQD,LIST_OF_QA_USERS,DUE_N_DAY_FROM_OVERDUE_UNLOCK,RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT,INTIMATION_SCHEDULED,INTIMATION_SENT_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,MARKED_AS_COMPLETED_BY,USER_TRAINING_COMMENTS,FINAL_SCORE,FAILED_ATTEMPTS,FAILED_ATTEMPTS_AFTER_UNLOCK,FAILED_ATTEMPT_REACHED,MAX_FAILED_ATTEMPT_REACHED,RELAUNCH_REASON,ESIGNATURE_DONE,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,NO_OF_OVERDUE_UNLOCK,NO_OF_FAILED_UNLOCK,NO_OF_TIMES_COMPLETED,TRAINER_NAME,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,User Name,User Full Name,Is User Active,Email Address,Scheduled Training Status,Scheduled Training Assessment,Start Date,End Date,Action Required,Comments,Review Status,Reviewed By,Reviewed On,Version,Status,Expiry Date,User Training Status,Level Status,Considered for Report,Reason for Not Considered at Report,Training Assigned On,Due Date,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Day From Assigned,Remind N Day Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users,Due N Day From Overdue Unlock,Retake After N Min on Failed Attempt,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked as Completed By,User Training Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,No of Overdue Unlock,No of Failed Unlock,No of Times Completed,Trainer Name,Deleted by User,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? " AND REVIEW_PERIOD_ID=" + this.message.reviewPeriodIdVal + " AND USER_ID=" + this.message.userIdVal : " AND REVIEW_PERIOD_ID=" + this.message.reviewPeriodIdVal + " AND USER_ID=" + this.message.userIdVal + " AND USER_TRAINING_ID=" + userTrainingReview;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,User Name,User Full Name,Is User Active,Email Address,Scheduled Training Status,Scheduled Training Assessment,Start Date,End Date,Action Required,Comments,Review Status,Reviewed By,Reviewed On,Version,Status,Expiry Date,User Training Status,Level Status,Considered for Report,Reason for Not Considered at Report,Training Assigned On,Due Date,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Day From Assigned,Remind N Day Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users,Due N Day From Overdue Unlock,Retake After N Min on Failed Attempt,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked as Completed By,User Training Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,No of Overdue Unlock,No of Failed Unlock,No of Times Completed,Trainer Name,Deleted by User,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? " WHERE REVIEW_PERIOD_ID=" + this.message.reviewPeriodIdVal + " AND USER_ID=" + this.message.userIdVal : " WHERE REVIEW_PERIOD_ID=" + this.message.reviewPeriodIdVal + " AND USER_ID=" + this.message.userIdVal + " AND USER_TRAINING_ID=" + userTrainingReview;
    this.message.report_And_Popup_Name = "User Training Review Detail Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(userTrainingReview);
  }
}
